import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(panel => ({
        value: panel.id,
        label: panel.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      try {
        const { data } = await axios.get('v1/bosch/panels', { params });

        if (!data) {
          return []
        }

        commit('setData', data.data);
        return data;

      } catch (error) {
        console.error('Error fetching panels:', error);
        return [];
      }
    },

    async add(_, params) {
      try {
        const { data } = await axios.post('v1/bosch/panels', params)

        return data;
      } catch (error) {
        console.error('Error creating panel:', error);
        throw error;
      }
    },

    async show(_, id) {
      try {
        const { data } = await axios.get(`v1/bosch/panels/${id}`)

        return data;
      } catch (error) {
        console.error('Error fetching panel:', error);
        throw error;
      }
    },

    async edit(_, { id, params }) {
      try {
        const { data } = await axios.put(`v1/bosch/panels/${id}`, params)

        return data;
      } catch (error) {
        console.error('Error updating panel:', error);
        throw error;
      }
    },

    async delete(_, id) {
      try {
        const {data} = await axios.delete(`v1/bosch/panels/${id}`)

        return data;
      } catch (error) {
        console.error('Error deleting panel:', error);
        throw error;
      }
    },

    async syncDevices(_, id) {
      try {
        const { data } = await axios.get(`v1/bosch/panels/${id}/sync-devices`)

        return data;
      } catch (error) {
        console.error('Error syncing devices:', error);
        throw error;
      }
    },

    async armPanel(_, params) {
      try {
        const { data } = await axios.post('v1/bosch/panels/arm', params)

        return data;
      } catch (error) {
        console.error('Error arming/disarming panel:', error);
        throw error;
      }
    },

    clear({ commit }) {
      commit('setData', [])
    }
  },
}
